var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2 6.818C2 6.366 2.381 6 2.851 6H21.15c.47 0 .851.366.851.818s-.381.817-.851.817H2.85c-.47 0-.851-.366-.851-.817m0 5.641c0-.451.381-.817.851-.817h12.085c.47 0 .851.366.851.817 0 .452-.38.818-.85.818H2.85c-.47 0-.851-.366-.851-.818m0 5.723c0-.451.381-.817.851-.817H8.81c.47 0 .85.366.85.817 0 .452-.38.818-.85.818H2.85c-.47 0-.851-.366-.851-.818",
    clipRule: "evenodd"
  })));
};
export default SvgSort;